export { FrameContexts as MetaOsHubFrameContexts } from '@microsoft/teams-js';
import { pages } from '@microsoft/teams-js';

import { isInMetaOsHub } from './isInMetaOsHub';

type RegisterBackButtonHandlerProps = Parameters<(typeof pages)['backStack']['registerBackButtonHandler']>;

type RegisterBackButtonHandler = (...params: RegisterBackButtonHandlerProps) => Promise<void>;
export const registerBackButtonHandler: RegisterBackButtonHandler = async (params) => {
  const inMetaOsHubContext = await isInMetaOsHub();
  const isBackSupported = pages.backStack.isSupported();
  const shouldRegisterHandler = inMetaOsHubContext && isBackSupported;

  if (!shouldRegisterHandler) {
    return;
  }

  pages.backStack.registerBackButtonHandler(params);
};
